import React, { useState } from 'react'
import { EntryPage, PasswordResetForm } from '@emerald-works-nova/auth'
import { Grid } from '@mui/material'
import { Auth } from '@aws-amplify/auth'

const ResetPasswordFormPage = ({ onFinalize, code, username }) => {
  const [isResetting, setIsResseting] = useState(false)
  const [error] = useState({ isError: false, message: null })

  const handleResetPassword = async (data) => {
    try {
      await Auth.forgotPasswordSubmit(username, code, data.password)
      onFinalize('success')
    } catch (error) {
      onFinalize('error')
    } finally {
      setIsResseting(false)
    }
  }

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }} />
      <Grid item>
        <EntryPage
          title='Please enter your new password.'
          showMtLogo
          content={
            <PasswordResetForm onResetPassword={handleResetPassword} isResetting={isResetting} error={error} />
          }
          application={process.env.REACT_APP_APPLICATION_NAME}
        />
      </Grid>
    </Grid>
  )
}

export default ResetPasswordFormPage
